import { Injectable, signal, inject } from '@angular/core'
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker'
import { filter } from 'rxjs'
import { LoggerService } from './logger.service'

@Injectable()
export class VersionService {
  private updates = inject(SwUpdate)
  private loggerService = inject(LoggerService)

  /** Read by `AppComponent` to declaratively show the update popup at the app root. */
  public readonly showUpdatePopup = signal(false)

  constructor() {
    // Check for updates during "visibilitychange" event
    document.addEventListener('visibilitychange', this.visibilityChangeHandler)

    this.updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        this.showUpdatePopup.set(true)
      })

    // Check for updates during application start
    this.checkForUpdates()
  }

  private visibilityChangeHandler = () => {
    if (document.visibilityState === 'visible') {
      this.checkForUpdates()
    }
  }

  checkForUpdates() {
    if (!this.updates.isEnabled) {
      this.loggerService.log('SW not enabled')
      return
    }

    this.updates
      .checkForUpdate()
      .then((updateFound: boolean) => {
        this.loggerService.log(updateFound ? 'A new version is available.' : 'Already on the latest version.')
      })
      .catch((error) => {
        this.loggerService.log('Error checking for updates', error)
      })
  }
}
